import { Body, dsColors, FlexBox, fontFamily } from '@Backlot-Cars/archie';
import styled from 'styled-components';

export const ProgressBarContainer = styled.div`
	display: flex;
	flex-direction: row;
	width: 100%;
	height: 52px;
`;

const statusColors = {
	pending: {
		background: 'primary',
		border: dsColors.colorBorder.primary,
		font: dsColors.colorText.secondary,
	},
	active: {
		background: 'primary',
		border: dsColors.colorBrand.secondary,
		font: dsColors.colorBrand.secondary,
	},
	completed: {
		background: dsColors.colorBrand.secondary,
		border: dsColors.colorBrand.secondary,
		font: dsColors.colorText.invert,
	},
};

export const StepContainer = styled.div`
	position: relative;
	display: flex;
	flex-direction: column;
	gap: 8px;
`;

export const StepNamePositioner = styled.div`
	display: flex;
	position: relative;
	justify-content: ${({ position }) => position};
`;

export const StepNameLabel = styled(Body).attrs({ bold: true, size: 'smaller' })`
	display: flex;
	position: absolute;
`;

export const StepCircle = styled(FlexBox)`
	width: 24px;
	height: 24px;
	align-items: center;
	justify-content: center;
	border-radius: 50%;
	border: 2px solid;
	font-size: 16px;
	font-weight: var(--fontWeightSemiBold);
	font-family: ${fontFamily};
	color: ${({ status }) => statusColors[status].font};
	background-color: ${({ status }) => statusColors[status].background};
	border-color: ${({ status }) => statusColors[status].border};
`;

export const Spacer = styled.div`
	display: flex;
	height: 4px;
	margin: 10px 2px;
	border-radius: 2px;
	flex: 1;

	background-color: ${({ status }) => statusColors[status].border};
`;
